import React from "react";
import { Thermometer, Wind, Sun, Cpu, Droplets, Flame, Building2, SquareStack, Layers, Hammer } from "lucide-react";
import { useLanguage } from "../context/LanguageContext";

const iconMap = {
  heat_pumps: Wind,
  floor_heating: Thermometer,
  photovoltaic: Sun,
  knx: Cpu,
  plumbing: Droplets,
  gas: Flame,
  thermal_facade: Building2,
  aluminum: SquareStack,
  drywall: Layers,
  renovation: Hammer,
};

const Services = () => {
  const { t } = useLanguage();
  return (
    <section id="services" data-testid="services-section" className="relative bg-[#F7F5F2] py-32 lg:py-44">
      <div className="max-w-7xl mx-auto px-6 md:px-12 lg:px-20">
        <div className="flex flex-col lg:flex-row lg:items-end lg:justify-between gap-10 mb-20">
          <div>
            <div className="flex items-center gap-4 mb-8">
              <span className="w-14 h-px bg-[#B08D57]"></span>
              <span className="overline-bold text-[#B08D57]">{t.services.overline}</span>
            </div>
            <h2 className="font-display-thin text-[#0F0F0F] text-4xl sm:text-5xl lg:text-[68px] tracking-tight leading-[1.05] max-w-3xl">
              {t.services.title}
            </h2>
          </div>
          <p className="text-[#3A3A37] max-w-md text-base leading-[1.75]">{t.services.subtitle}</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-5 gap-px bg-[#0F0F0F]/8 border border-[#0F0F0F]/8">
          {t.services.items.map((item, idx) => {
            const Icon = iconMap[item.key] || Building2;
            return (
              <div
                key={item.key}
                data-testid={`service-card-${item.key}`}
                className="group bg-[#F7F5F2] p-8 lg:p-10 hover:bg-white transition-all duration-500 relative min-h-[280px] flex flex-col"
              >
                <span className="overline text-[#0F0F0F]/25 absolute top-7 right-7">
                  {String(idx + 1).padStart(2, "0")}
                </span>
                <div className="mb-10">
                  <div className="w-14 h-14 flex items-center justify-center border border-[#B08D57]/40 group-hover:border-[#B08D57] group-hover:bg-[#B08D57]/5 transition-colors">
                    <Icon className="w-6 h-6 text-[#B08D57]" strokeWidth={1.2} />
                  </div>
                </div>
                <h3 className="font-display text-[#0F0F0F] text-lg leading-tight mb-3 group-hover:text-[#B08D57] transition-colors">
                  {item.title}
                </h3>
                <div className="hairline mb-4"></div>
                <p className="text-[#3A3A37] text-[13px] leading-[1.7] font-light flex-1">{item.desc}</p>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default Services;
